import React, { Component } from "react";
import AsideNavbar from "../components/navbars/AsideNavbar";
import Navbars from "../components/navbars/Navbars";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import AiSimilarQuestionModels from "../components/aiSimilarQuestions/aiTutorSimilarQuestionsModel";
import AiSimilarQuestionModels2 from "../components/aiSimilarQuestions/aiTutorSimilarQuestionsModel2";

class AiTutorSimilarQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerQueryA: null,
      triggerQueryTextA: "",
      triggerQueryB: null,
      triggerQueryTextB: "",
      question: "How does a mechanism contribute to a machine's function?",
      class: "11",
      subject: "Physics",
      question_id: "123467",
    };
  }

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  handleQuestionsClickA = () => {
    this.setState({
      triggerQueryA: Date.now(),
      triggerQueryTextA: "sample question A",
      question: "What is React?",
      class: "10",
      subject: "Computer Science",
      question_id: "qA-123a",
    });
  };

  handleQuestionsClickB = () => {
    this.setState({
      triggerQueryB: Date.now(),
      triggerQueryTextB: "sample question B",
      question: "Explain components",
      class: "12",
      subject: "Computer Science",
      question_id: "qB-416af",
    });
  };

  render() {
    if (Cookies.get("studenttoken") == undefined) this.props.history.push("/student/login");

    let studentGlobals = "";
    if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
      studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
    } else {
      this.props.history.push("/student/login");
    }

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <Navbars onClick={() => this.menuToggler()} />
        </div>

        <div className="main-wrapper">
          <AsideNavbar onClick={() => this.menuToggler()} />
          <div className="student-overlay" onClick={() => this.menuToggler()} />

          <div className="content-wrapper">
            <button className="btn btn-primary btn-sm" onClick={this.handleQuestionsClickA}>
              Questions A
            </button>

            <button className="btn btn-success btn-sm ml-2" onClick={this.handleQuestionsClickB}>
              Questions B
            </button>

            <AiSimilarQuestionModels
              triggerQuery={this.state.triggerQueryA}
              triggerQueryText={this.state.triggerQueryTextA}
              question={this.state.question}
              className={this.state.class}   // ✅ use className (class is reserved)
              subject={this.state.subject}
              question_id={this.state.question_id}

            />
            <AiSimilarQuestionModels2
              triggerQuery={this.state.triggerQueryB}
              triggerQueryText={this.state.triggerQueryTextB}
              question={this.state.question}
              className={this.state.class}   // ✅ use className (class is reserved)
              subject={this.state.subject}
              question_id={this.state.question_id}

            />
          </div>

        </div>
      </div>
    );
  }
}

export default withRouter(AiTutorSimilarQuestions);
